import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../utils/services/api.service';
import { FormControl } from '@angular/forms';
import { ParameterService } from '../../../utils/services/parameter.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-system-hotel-requests',
  templateUrl: './system-hotel-requests.component.html',
  styleUrls: ['./system-hotel-requests.component.css']
})
export class SystemHotelRequestsComponent implements OnInit {

  systemHotels;
  searchParams = new URLSearchParams();
  statuses = [
    {
      key: 'Active',
      value: 'Active'
    },
    {
      key: 'PendingConfirmation',
      value: 'Pending Confirmation'
    },
    {
      key: 'Decline',
      value: 'Decline'
    },
    {
      key: 'Inactive',
      value: 'Inactive'
    },
    {
      key: 'New',
      value: 'New'
    },
    {
      key: null,
      value: 'All'
    }
  ];
  loading = true;
  statusFilter = new FormControl('PendingConfirmation');
  hotelNameFilter = new FormControl('');
  pageNumber = new FormControl('1');
  city = new FormControl(null);
  pageNumbers = [1];
  offset = 0;
  pageUpperLimit = 10;
  pageLowerLimit = 0;
  constructor(private api: ApiService, private parameter: ParameterService, private notification: NotificationsService) { }

  ngOnInit() {
    let offset = ((+this.pageNumber.value) - 1) * 10;
    this.searchParams.set('status_In', 'PendingConfirmation');
    this.searchParams.set('offset', this.offset.toString());
    this.searchParams.set('limit', "10");
    this.searchParams.set('sortBy', "id");
    this.searchParams.set('sortType', "desc");
    this.api.getHotels(this.searchParams).subscribe(res => {
      this.pageNumbers = [];
      //this.pageNumber.patchValue(res.data.count ? Math.ceil(res.data.count / 10) : "?");
      for (let index = 1; index <= Math.ceil(res.data.count / 10); index++) {//kac otel varsa ona gore sayfa sayisini ayarla
        this.pageNumbers.push(index);
      }
      if(res.data.rows.length != 0) {
        this.systemHotelMapper(res)
      } else {
        this.loading=false;
        this.notification.warn('There is no pending confirmation requests!')
      }
    }, err => {
      this.loading = false;
      this.notification.error(err.error.message);
    })
  }

  onFilter(reset?) {
    if(reset) {
      this.offset= 0;
      this.pageLowerLimit = 0;
      this.pageUpperLimit = 10;
    }
    this.searchParams = new URLSearchParams();
    if (this.hotelNameFilter.value) {
      this.searchParams.set('name_Like', this.hotelNameFilter.value);
    } else {
      this.searchParams.delete('name_Like');
    }
    if (this.statusFilter.value)
      this.searchParams.set('status_In', this.statusFilter.value);
    if(this.city.value && this.city.value.length > 0) {
      let cities = this.city.value.map(item => item.id);
      this.searchParams.set('cityId_In', cities);
    }
    this.searchParams.set('offset', this.offset.toString());
    this.searchParams.set('limit', "10");
    this.searchParams.set('sortBy', "id");
    this.searchParams.set('sortType', "desc");
    this.loading = true;
    this.api.getHotels(this.searchParams).subscribe(res => {
      this.pageNumbers = [];
      for (let index = 1; index <= Math.ceil(res.data.count / 10); index++) {//kac otel varsa ona gore sayfa sayisini ayarla
        this.pageNumbers.push(index);
      }
      if(res.data.rows.length != 0) {
        this.systemHotelMapper(res)
      } else {
        this.loading = false;
        this.systemHotels = [];
        this.pageNumbers = [];
        this.notification.warn('There is no any data!')
      }
    }, err => { 
      this.offset=0;
      this.pageUpperLimit = 10;
      this.pageLowerLimit = 0;
      this.pageNumbers = [];
      this.systemHotels = [];
      this.loading = false;
    })
  }

  setPage(pageNumber) {
    if(pageNumber+2 >= this.pageUpperLimit)
     this.pageUpperLimit = pageNumber+5;
    
    this.pageLowerLimit = pageNumber-5;
    if(this.pageLowerLimit < 0) {
      this.pageLowerLimit = 0;
      this.pageUpperLimit = 10;
    }
    this.offset = ((+pageNumber) - 1) * 10;
    this.onFilter();
  }

  systemHotelMapper(res) {
    let cities = Array.from(new Set(res.data.rows.map(p => p.cityId)));

    this.parameter.getCities('id_In=' + cities.toString()).subscribe(city => {
      this.systemHotels = res.data.rows.map(p => {
        let data = city.data.find(c => c.bizihotelCityId === p.cityId);
        if (data) {
          p.cityName = data.name;
        }
        return p;
      });
      this.loading = false;
    }, err => {
      this.systemHotels = [];
      this.loading = false;
      this.notification.error(err.error.message);
    })

  }

  statusNamify(data) {
    return this.statuses.filter(p => p.key === data)[0].value;
  }

  approve(hotel) {
    this.loading = true;
    this.api.updateHotelStatus(hotel.id, { status: 'Active' }).subscribe(res => {
      this.api.getHotels(this.searchParams).subscribe(res => {
        this.systemHotelMapper(res);
        this.notification.success('Approved');
      }, err => {
        this.notification.error(err.error.message);
        this.loading = false;
      })
    }, err => {
      this.notification.error(err.error.message);
      this.loading = false;
    })
  }

  changePage(increamentAmount) {
    this.offset += increamentAmount * 10;
    if(this.offset/10 + 2 >= this.pageUpperLimit) {
      this.pageUpperLimit = this.offset/10+5;
    }
    this.pageLowerLimit = this.offset/10-5;
    if(this.pageLowerLimit < 0) {
      this.pageLowerLimit = 0;
      this.pageUpperLimit = 10;
    }

    if (this.offset < 0)
      this.offset = 0;

    this.onFilter();
  }

  decline(hotel) {
    this.loading = true;
    this.api.updateHotelStatus(hotel.id, { status: 'Decline' }).subscribe(res => {
      this.api.getHotels(this.searchParams).subscribe(res => {
        this.systemHotelMapper(res);
        this.notification.success('Declined');
      }, err => {
        this.loading = false;
        this.notification.error(err.error.message);
      })
    }, err => {
      this.loading = false;
      this.notification.error(err.error.message);
    })
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/system-hotel-requests/system-hotel-requests.component.ts